<template lang="pug">
.section-main.full-width.relative(
  :class="{ 'filter-blur-1 pointer-events-none': loading }"
)
  .absolute.left-0.top-0.pa-8.z-index-10.d-flex.full-width.pointer-events-none.flex-wrap.align-center(
    v-if="canEdit"
    :class=`{
      'gap-8': $vuetify.breakpoint.xs,
      'gap-16': $vuetify.breakpoint.smAndUp,
    }`
  )
    dv-btn.mr-2.ui-primary--text.px-4.pointer-events-all(
      v-if="isRouteEditor"
      :to="$user.isAdmin ? '/event-templates' : { name: 'ui-event-dashboard-main-settings', params: { id: event.id } }"
      color="ui-bright"
    )
      v-icon.mr-2(size="20") $ui-arrow-left
      | Вернуться назад

    tooltip-wrap(
      right
      content-class="redesign redesignControlsBackground redesign-box-shadow rounded-8 opacity-100"
    )
      template(#reason)
        p.redesignPrimaryDarken--text Статус мероприятия
      dv-chip.rounded-pill.pointer-events-all(
        :color="EVENT_STATUS_DATA[event.status].color"
        :text-color="EVENT_STATUS_DATA[event.status].textColor"
        :height="36"
      )
        .body-1 {{ EVENT_STATUS_DATA[event.status].text }}

    tooltip-wrap(
      v-for="(btn, idx) in filteredButtons"
      :key="idx"
      :disabled="!btn.icon"
      right
      bottom
      content-class="redesign redesignControlsBackground redesign-box-shadow rounded-8 opacity-100"
      :class="{ 'd-block ml-auto': idx === 0 }"
    )
      template(#reason)
        p.redesignPrimaryDarken--text(
          :class="{ 'text-nowrap': !$vuetify.breakpoint.xs }"
        ) {{ btn.text }}
      dv-btn.pointer-events-all(
        :height="36"
        :icon="!!btn.icon"
        :width="btn.icon ? 36 : 'unset'"
        :class="[{ 'px-4': !btn.icon }, { 'px-0': btn.icon }, btn.attrs.class]"
        v-bind="btn.attrs"
        @click="btn.click"
      )
        v-icon(v-if="btn.icon" size="20") {{ btn.icon }}
        p.ui-body-1(v-else) {{ btn.text }}

    event-actions(
      :event="event"
      :sections="sections"
    )

  .absolute.left-0.bottom-0.z-index-10.ma-4(v-if="event.showQR")
    event-qr(:event="event")

  main-container.full-width(
    :event="event"
    :isEditable="canEdit"
  )
</template>

<script>
import MainContainer from '@/modules/UserEventLanding/components/event-landing/main/MainContainer.vue';
import EventActions from '@/modules/UserEventLanding/components/event-landing/main/EventActions.vue';
import AppButton from '@/components/user-redesign/controls/AppButton.vue';
import EventQr from '@/modules/Events/components/informing/invitations/EventQR.vue';
import { EVENT_STATUS, EVENT_STATUS_CONCEALED, EVENT_STATUS_TEXT } from '@/modules/Events/constants.js';
import DvChip from '@/packages/ui/components/chips/DvChip.vue';
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';

export const EVENT_STATUS_DATA = {
  [EVENT_STATUS.ACTIVE]: {
    text: EVENT_STATUS_TEXT[EVENT_STATUS.ACTIVE],
    color: 'redesignSuccess',
    textColor: 'redesignControlsBackground',
  },
  [EVENT_STATUS.DRAFT]: {
    text: EVENT_STATUS_TEXT[EVENT_STATUS.DRAFT],
    color: 'redesignDisabledText',
    textColor: 'redesignBlack',
  },
  [EVENT_STATUS.MODERATE]: {
    text: EVENT_STATUS_TEXT[EVENT_STATUS.MODERATE],
    color: 'redesignWarning',
    textColor: 'redesignBlack',
  },
  [EVENT_STATUS.MODERATE_REFUSE]: {
    text: EVENT_STATUS_TEXT[EVENT_STATUS.MODERATE_REFUSE],
    color: 'redesignError',
    textColor: 'redesignControlsBackground',
  },
  [EVENT_STATUS.CLOSED]: {
    text: EVENT_STATUS_TEXT[EVENT_STATUS.CLOSED],
    color: 'redesignError',
    textColor: 'redesignControlsBackground',
  },
  [EVENT_STATUS_CONCEALED.TEMPLATE]: {
    text: EVENT_STATUS_TEXT[EVENT_STATUS_CONCEALED.TEMPLATE],
    color: 'redesignDisabledText',
    textColor: 'redesignControlsBackground',
  },
};

export default {
  name: 'SectionMain',

  components: {
    AppButton,
    MainContainer,
    EventActions,
    EventQr,
    DvChip,
    DvBtn,
  },

  props: {
    event: { type: Object, required: true },
    isEditable: { type: Boolean, required: false },
    eventManagerAccess: { type: Boolean, default: false },
    sections: { type: Array, default: () => [] },
  },

  data() {
    return {
      EVENT_STATUS_DATA,
      loading: false,
    };
  },

  computed: {
    canEdit() {
      const { $conf, event, $user, isEditable, eventManagerAccess } = this;
      if (!$user.isEventManager) return isEditable;
      const { PERMISSIONS } = $conf;
      return eventManagerAccess && this.$user.hasPermissionsWithManyOptions(
        [PERMISSIONS.event_update],
        [{ event_id: event.id }, {}],
        { all: false },
      );
    },
    isRouteEditor() {
      return !!this.$route.meta.editor;
    },
    manageButtons() {
      const { name } = this.$route;
      return [
        // {
        //   text: 'Сохранить все изменения конструктора',
        //   icon: '$isave',
        //   click: () => this.$emit('save'),
        //   attrs: {
        //     color: 'redesignPrimary',
        //     elevation: 0,
        //     class: 'redesignControlsBackground--text',
        //   },
        // },
        {
          text: 'Сбросить все изменения конструктора',
          icon: '$ui-arrow-path',
          click: () => this.$emit('restore'),
          attrs: {
            color: 'ui-primary',
            class: 'ui-bright',
          },
        },
        {
          hidden: name === 'event-landing-redesign',
          text: 'Предпросмотр',
          click: () => ({}),
          attrs: {
            color: 'ui-bright',
            class: 'redesignPrimaryDarken--text',
            target: '_blank',
            to: {
              name: 'event-landing-redesign',
              params: {
                id: this.event.id,
              },
            },
          },
        },
      ];
    },
    filteredButtons() {
      return this.manageButtons.filter((item) => !item.hidden);
    },
  },
};
</script>

<style lang="scss" scoped>
.section-main {
  min-height: 90vh;
}
</style>
